import React, { Component } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router';
import Login from './Login';
import HomeCertificate from './HomeCertificate';
import VerifyUser from './VerifyOtp';

class App extends Component {

  render() {
    return (

      <Router>
        <Routes>
          <Route path="/" element={<Login />} render={(props) => <Login {...props} ref={this.state} />} />
          <Route path="/verifyUser" element={<VerifyUser />}  render={(props) => <VerifyUser {...props} refreshRout={"/verifyUser"} ref={this.state} />} />
          <Route path="/certificate" element={<HomeCertificate />} render={(props) => <HomeCertificate {...props} ref={this.state} />} />
        </Routes>
      </Router>
    );
  }
}

export default App;
